<ion-app>
  <ion-router-outlet [animation]="myTransition"></ion-router-outlet>
</ion-app>
